export default "__VITE_ASSET__D6qyA1om__"